export const useStyles = (theme) => ({
  root: {
    padding: 20,
    minHeight: "50vh",
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  paper: {
    padding: 10,
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down(500)]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  coverImageStyle: {
    width: 200,
    height: 260,
    [theme.breakpoints.down(500)]: {
      width: 250,
      height: 350,
    },
  },
});
